import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { SelectInput } from '@atlassian/mpac-ui';
import React from 'react';

const getHourOptions = () => {
  const options = [];

  for (let i = 0; i < 24; i++) {
    let value;

    if (i < 10) {
      value = '0' + i.toString();
    } else {
      value = i.toString();
    }

    options.push({
      label: value,
      value
    });
  }

  return options;
};

const TimeSelectContainer = _styled("div", {
  target: "e15egsda0",
  label: "TimeSelectContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "pi60e7",
  styles: "display:inline-block;max-width:150px;width:100%;margin:0px 10px;"
} : {
  name: "pi60e7",
  styles: "display:inline-block;max-width:150px;width:100%;margin:0px 10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const CustomHoursSelection = ({
  range
}) => {
  const from = range === null || range === void 0 ? void 0 : range.from;
  const until = range === null || range === void 0 ? void 0 : range.until;
  const [fromHour, fromMinute] = from ? from.split(':') : ['00', '00'];
  const [untilHour, untilMinute] = until ? until.split(':') : ['00', '00'];
  const hourOptions = getHourOptions();
  const minuteOptions = [{
    label: '00',
    value: '00'
  }, {
    label: '30',
    value: '30'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "fromHour",
    label: "Start Time",
    options: hourOptions,
    defaultValue: {
      value: fromHour,
      label: fromHour
    }
  })), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "fromMinute",
    label: "",
    options: minuteOptions,
    defaultValue: {
      value: fromMinute,
      label: fromMinute
    }
  })), /*#__PURE__*/React.createElement("span", null, " : "), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "untilHour",
    label: "End Time",
    options: hourOptions,
    defaultValue: {
      value: untilHour,
      label: untilHour
    }
  })), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "untilMinute",
    label: "",
    options: minuteOptions,
    defaultValue: {
      value: untilMinute,
      label: untilMinute
    }
  })));
};

export default CustomHoursSelection;